module.exports = __webpack_public_path__ + "img/PL08071.5d250424.png";